import { get } from './api';
import routes from './end-points';

export const userValidationsApi = {
  list: () => get(routes.userValidation.list),
};
